/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package coreui.compose

enum class TextFieldType {
    TEXT,
    PASSWORD,
    EMAIL
}